module.exports = __webpack_public_path__ + "static/pic21-70aaa3b486478ee8f97d8059803f6441.jpg";